import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { SellOrderStatusBarProps } from '../../../../../SellOrders/SingleSellOrder/SellOrderStatusBar'
import SellInvoiceStatusBar, { SellInvoiceStatusBarNew } from '../../../SellInvoiceStatusBar'
import SellInvoiceCreateNoPermissionButtons, { SellInvoiceCreateNoPermissionButtonsNew } from '../SellInvoiceCreateNoPermissionButtons'

type SellInvoiceCreateNoPermissionStepHeaderProps = & SellOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const SellInvoiceCreateNoPermissionStepHeaderDecider: React.FC<SellInvoiceCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellInvoiceCreateNoPermissionStepHeaderDefault} NewComponent={SellInvoiceCreateNoPermissionStepHeaderNew} {...rest} />
    )
}

const SellInvoiceCreateNoPermissionStepHeaderDefault: React.FC<SellInvoiceCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellInvoiceStatusBar {...rest} />
            <SellInvoiceCreateNoPermissionButtons {...rest} />
        </div>
    )
}

const SellInvoiceCreateNoPermissionStepHeaderNew: React.FC<SellInvoiceCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellInvoiceStatusBarNew {...rest} />
            <SellInvoiceCreateNoPermissionButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellInvoiceCreateNoPermissionStepHeaderDecider